"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFailureModes = void 0;
const Predicate_1 = require("effect/Predicate");
const capability_1 = require("../../capability");
const _util_1 = require("../_util");
const getFailureModes = (device) => {
    const [microPurityFilter, co2Tank] = device.consumables;
    const alarms = device.alarms.map(({ alarm }) => alarm);
    const enhancements = [co2Tank];
    const filters = [microPurityFilter];
    return {
        sanitization: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.UvNotPresent),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.UvOverTemp),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.UvUnderCurrent),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.UvOverCurrent),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.UvCommsError),
        ],
        dripTrayAndLeak: [(0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.WaterLeak)],
        enhancements: enhancements.filter(Predicate_1.isNotNullable).map(_util_1.getFailureModeSlot),
        heatingStatus: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.BoilDryProtection),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.HtbHotTankTimeout),
        ],
        chillingStatus: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.CompressorOverRun),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.CompressorDriverFault),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.CompressorFuse),
        ],
        waterQuality: filters.filter(Predicate_1.isNotNullable).map(_util_1.getFailureModeSlot),
    };
};
exports.getFailureModes = getFailureModes;
//# sourceMappingURL=failure-mode.js.map